
export const userInfo = JSON.parse(localStorage.getItem('userInfo'))
export const getPermission = (permissionKey) => userInfo ? userInfo[permissionKey]?.includes('True') : false
